const Style = {
    lede: 'mb-14 mt-3 max-w-[620px] text-base text-text-secondary md:text-lg',
    grid: 'grid gap-11 sm:grid-cols-2 lg:grid-cols-4',
    well: 'mb-4 flex h-11 w-11 items-center justify-center rounded-lg border border-primary-200 bg-primary-50',
    title: 'mb-2 mt-0 text-lg font-semibold text-text-primary',
    desc: 'm-0 text-sm leading-relaxed text-text-secondary',
};

export default Style;
